//  Created through Auth0 rule
export const AUTH0_ACCESS_TOKEN_NAMESPACE = 'https://api.resilia.com'

export const AUTH0_CUSTOMER_SUCCESS_ROLE = 'customer_success'
